import React from "react";
import styles from "./apiDescriptor.module.scss";

interface Props {
  title: string;
  description: { apiInfo: string, apiSpecifications: string[] };
}

const ApiDescriptor: React.FC<Props> = (props) => {
  return (
    <>
      <div>
        <div className={styles.title}>{props.title}</div>
        {props.description?.apiInfo != props.title && <div className="text-start pt-2">{props?.description?.apiInfo}</div>}
        {props.description?.apiSpecifications?.length > 0 && (
          <>
            <div className={styles.specTitle + " py-2"}>API Specification</div>
            <div>
              <ul>
                {props?.description?.apiSpecifications.map((spec, index) => (
                  <li key={index} className="text-start">
                    {spec}
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ApiDescriptor;
